import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import apiConstants from "./api-constants";

const origin = window.location.origin;

const getBaseUrl = () => {
  let baseUrl = "https://api-marketplace-prod.k2.isw.la";
  if (/http:\/\/localhost/i.test(origin) || /.qa.interswitchng.com/i.test(origin)) {
    baseUrl = "https://api-marketplace.k8.isw.la";
  }
  return baseUrl;
};


const baseUrl = getBaseUrl()

export const apiSlice = createApi({
  reducerPath: "apiSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/api/v1`,
    prepareHeaders: (headers) => {
      if (!headers.has("no-header")) {
        headers.set("Content-Type", "application/json");
      }

      headers.set("X-XSRF-TOKEN", apiConstants.XSRF);
      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: ["projects", "project"],
});